<div class="content-section" [ngClass]="{'expand' : layoutService.expandedMenu, 'noTabScreen':noTabScreen}" [style.background]="getBackgroundColor()">
    <lib-campaigns *ngIf="!mustShowCampaign()"></lib-campaigns>
    <div class="title-section h-100 title-bar title-bar-nav" *ngIf="isDesktop && noTabScreen">
        <div class="title-div d-flex align-items-center">
            <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                <div class="p-0">
                    <h2 class="background_title">{{ 'INSTITUTION_MANAGEMENT.SOP_WORK_ROUTINE' | translate }}</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="container-filters" [ngClass]="{'noTabScreen':noTabScreen}">
        <div class="">
            <div class="d-flex justify-content-between container-nav">
                <nav class="p-0 nav nav-pills nav-title">
                    <a class="nav-link " [ngClass]="viewFlag=='all'?'active':''" (click)=" changeView('all')"> {{ 'SOP_MANAGEMENT.ALL' | translate }} ({{allSopDetails.length}})</a>
                    <a class="nav-link" [ngClass]="viewFlag=='draft'?'active':''" (click)="changeView('draft')">{{ 'SOP_MANAGEMENT.DRAFT' | translate }} ({{draftSopDetails.length}})</a>
                    <a class="nav-link" [ngClass]="viewFlag=='published'?'active':''" (click)="changeView('published')">{{ 'SOP_MANAGEMENT.PUBLISHED' | translate }} ({{publishedSopDetails.length}})</a>
                    <a *ngIf="userRole <= 2" class="nav-link" [ngClass]="viewFlag=='global'?'active':''" (click)="changeView('global')">{{ 'SOP_MANAGEMENT.GLOBAL_TEMPLATES' | translate }} ({{globalSopDetails.length}})</a>
                    <a *ngIf="userRole <= 2" class="nav-link" [ngClass]="viewFlag=='country'?'active':''" (click)="changeView('country')">{{ 'SOP_MANAGEMENT.COUNTRY_TEMPLATES' | translate }} ({{countrySopDetails.length}})</a>
                </nav>
                <div class="" *ngIf=isDesktop>
                    <button class="btn-bd-empty" (click)="newSop('/sop/create')">{{ 'SOP_MANAGEMENT.CREATE_SOP_WORK_ROUTINE' | translate }}</button>
                </div>
            </div>
        </div>
        <div class="search-div row justify-content-end align-items-center my-3">
            <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
        </div>
        <div id="sop-card-{{i + 1}}" class="card-strip" *ngFor="let sopDetail of sopDetails;let i = index">
            <div class="sop-box card-task" [ngClass]="{ 'master': sopDetail.type === 'Master', 'mt-2': i === 0 }" (click)="openCollapsed(i,sopDetail);" [attr.aria-expanded]="isCollapsed[i]">
                <div class="row cursor m-0 col-12 p-0">
                    <div class="col-auto p-0">
                        <div class="sop-media">
                            <img [ngClass]="(sopDetail.sopImage)?'svg':''" 
                            [src]="(sopDetail.sopImage)?layoutService.serverUrl+sopDetail.sopImage:'assets/img/fallback-img-gray.png'"
                            (error)="errImg($event)">
                        </div>
                    </div>
                    <div class="col p-2 sop-card">
                        <div class="absolute">
                            <button class="k-button" *ngIf="isDeleteAllowed(sopDetail)" (click)='draftDeleteSOP(sopDetail.sopid, sopDetail.createdBy)'  title="{{ 'LAYOUT_MODULE.DELETE' | translate }}">
                                <mat-icon outline>delete</mat-icon>
                            </button>
                        </div>
                        <div class="col-7 p-2 pl-2">
                            <span class="published mb-3">
                                {{  
                                    (sopDetail.draftStepsJson == '') ? 
                                        ('SOP_MANAGEMENT.PUBLISHED'| translate) : 
                                        ('SOP_MANAGEMENT.DRAFT'| translate)
                                }}
                                {{  
                                    (sopDetail.draftStepsJson == '') ? ':' : ''
                                }}
                                {{
                                    (sopDetail.draftStepsJson == '') ? 
                                        ((sopDetail.updatedDateTime !== null) ? 
                                            formatDateTime(sopDetail.updatedDateTime) : 
                                            formatDateTime(sopDetail.createdDateTime)) 
                                        : ''
                                }}
                              </span>
                            <div *ngIf="sopDetail.type == 'Master'" class="card-task-template-container">
                                <div class="card-task-template">{{ layoutService.translateText(translationKeys.SOPManagement.Template)| labelSanitizer}}</div>
                            </div>
                            <h5 class="mt-2 card-task-title">{{layoutService.translateText(sopDetail.title) | labelSanitizer}}</h5>
                            <p class="mb-0 card-task-desc">{{layoutService.translateText(sopDetail.description) | labelSanitizer}}</p>
                        </div>
                        <div class="col-5 pr-0 inst-list">
                            <span class="ints-list-title">{{sopDetail.sopInstitutions.length}} {{translationKeys.InstitutionManagement.Institutions | translate | labelSanitizer}}:</span>
                            <div class="inst-list-container">
                                <div class="instName" *ngFor="let institution of sopDetail.sopInstitutions; let j = index">{{institution.institutionName}}</div>
                            </div>
                        </div>
                        


                    </div>
                    <div class="col-12 p-0">
                        <div class="card collapse" id="viewVersions-{{i}}" *ngIf="isCollapsed[i]" [collapse]="!isCollapsed[i]">
                            <bd-light-table 
                                *ngIf="sopDetail.sopStepsVersions && sopDetail.sopStepsVersions.length > 0"
                                [gridData]="sopDetail.sopStepsVersions.slice(0,5)" 
                                [fields]="fields" 
                                [actions]="actionItems"
                                [actionsLast]=true
                                [classTable]="'sops'"
                                [showPaginator]="false"
                                >
                            </bd-light-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="alert alert-warning" role="alert" *ngIf="sopDetails && sopDetails.length == 0">
            {{ translationKeys.Dashboard.NoDataFound | translate }}</div>
    </div>
</div>



<ng-template #disclaimerModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'SOP_MANAGEMENT.INFORMATION_LIABILITY_USER_DEFINED_SOP' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="disclaimer();modalRef.hide();" class="btn-bd-empty">{{ 'CONFIGURE.ACCEPT' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #confirmModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{'SOP_MANAGEMENT.CONFIRMATION_DELETE_SOP_AND_OBSERVED_DATA_AND_EVALUATIONS' | translate}} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="DeleteSOP();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>